/* Auto-seeded FAQ items (portal from faq.html; landing starter set). */
export const FAQ_SEED_PORTAL = [
  {
    "id": "portal-getting-started-what-is-cookiecodejar",
    "surface": "portal",
    "section": "Getting started",
    "question": "What is CookieCodeJar?",
    "answer_html": "<p>\n                    CookieCodeJar is my kitchen of Episode assets: templates, overlays, mini-games,\n                    backgrounds, outfit lookbooks. Spend credits to unlock something, then re-download it from\n                    <strong>My Stash</strong> whenever you need it.\n                  </p>",
    "sort": 10
  },
  {
    "id": "portal-getting-started-do-i-need-a-ko-fi-membership-to-use-the-site",
    "surface": "portal",
    "section": "Getting started",
    "question": "Do I need a Ko-fi membership to use the site?",
    "answer_html": "<p>\n                    Nope. Free accounts can browse, grab free Asset Jar items, vote on the Baking List, and peek at the Lookbook.\n                    Ko-fi memberships are for monthly credits, Members Pantry, and the paid-tier extras.\n                  </p>",
    "sort": 20
  },
  {
    "id": "portal-credits-the-vault-what-are-credits",
    "surface": "portal",
    "section": "Credits & Asset Jar",
    "question": "What are credits?",
    "answer_html": "<p>\n                    Credits buy Asset Jar items. Each card shows the price. Once unlocked, it stays in\n                    <strong>My Stash</strong> with no second charge to download again.\n                  </p>",
    "sort": 30
  },
  {
    "id": "portal-credits-the-vault-do-unused-credits-expire",
    "surface": "portal",
    "section": "Credits & Asset Jar",
    "question": "Do unused credits expire?",
    "answer_html": "<p>\n                    No. Leftover credits stay in your jar. Monthly refills add on top.\n                  </p>",
    "sort": 40
  },
  {
    "id": "portal-credits-the-vault-how-do-i-get-more-credits",
    "surface": "portal",
    "section": "Credits & Asset Jar",
    "question": "How do I get more credits?",
    "answer_html": "<p>Credits land in your jar when you subscribe on Ko-fi (<strong>Cookie Dough</strong>, <strong>Cookie Batch</strong>, or <strong>Sugar Rush</strong>). Each paid month refills that tier’s amount.</p><p>Tap the credit pill, or go to <strong>My Counter → Membership</strong>. Through 10 Oct 2026, the first paid refill is doubled.</p>",
    "sort": 50
  },
  {
    "id": "portal-credits-the-vault-what-happens-when-i-unlock-something",
    "surface": "portal",
    "section": "Credits & Asset Jar",
    "question": "What happens when I unlock something?",
    "answer_html": "<p>\n                    Credits come off your jar and the asset lands in your library. Open <strong>My Stash</strong> to\n                    download or copy code from My Stash.\n                  </p>",
    "sort": 60
  },
  {
    "id": "portal-credits-the-vault-can-i-get-a-refund-on-credits-or-unlocks",
    "surface": "portal",
    "section": "Credits & Asset Jar",
    "question": "Can I get a refund on credits or unlocks?",
    "answer_html": "<p>\n                    Unlocks stick once you confirm. Can't \"return\" a digital file. If something's broken or wrong,\n                    email <a href=\"mailto:cookiecodejar@proton.me\">cookiecodejar@proton.me</a> or message me on Ko-fi or Instagram and I'll sort it out case by case.\n                  </p>",
    "sort": 70
  },
  {
    "id": "portal-membership-tiers-what-do-i-get-for-free-vs-each-paid-tier",
    "surface": "portal",
    "section": "Membership tiers",
    "question": "What do I get for free vs each paid tier?",
    "answer_html": "<ul><li><strong>The Crumb (free):</strong> browse, free unlocks, Baking List votes, Lookbook peeks.</li><li><strong>All paid tiers:</strong> monthly credits, Members Pantry, full Lookbook.</li><li><strong>Cookie Dough:</strong> 30 credits / 1 overlay request.</li><li><strong>Cookie Batch:</strong> 100 credits / 3 requests / lottery entry.</li><li><strong>Sugar Rush:</strong> 220 credits / 5 priority requests / extra lottery entries.</li></ul><p>Full comparison: <a href=\"profile.html#membership\">My Counter → Membership</a>.</p>",
    "sort": 80
  },
  {
    "id": "portal-membership-tiers-how-do-i-upgrade-downgrade-or-cancel",
    "surface": "portal",
    "section": "Membership tiers",
    "question": "How do I upgrade, downgrade, or cancel?",
    "answer_html": "<p>\n                    Handle it on Ko-fi. Tier and next charge date update here after Ko-fi processes the change.\n                    Cancelling Ko-fi doesn't delete your CookieCodeJar account. You keep unlocked assets, but\n                    monthly credits stop.\n                  </p>",
    "sort": 90
  },
  {
    "id": "portal-membership-tiers-how-does-ko-fi-link-to-my-cookiecodejar-account",
    "surface": "portal",
    "section": "Membership tiers",
    "question": "How does Ko-fi link to my CookieCodeJar account?",
    "answer_html": "<p>Prefer the <strong>same email</strong> on Ko-fi and CookieCodeJar. That’s the automatic link.</p><ul><li>Already free here? Subscribe on Ko-fi with that email. Tier + credits update after payment confirms.</li><li>Joined Ko-fi first? Create CookieCodeJar with the same email, confirm it, then sign in.</li><li>Different Ko-fi email? On My Counter → Membership, enter the email you paid with. Only one account can claim it.</li></ul>",
    "sort": 100
  },
  {
    "id": "portal-membership-tiers-what-is-featured-outfits-access",
    "surface": "portal",
    "section": "Membership tiers",
    "question": "What is Lookbook access?",
    "answer_html": "<p>\n                    A lookbook of Episode CC combos I've put together (Lookbook in the menu).\n                    Free accounts get a preview; paid membership unlocks the full set.\n                    If your sub lapses, preview stays, full looks lock again.\n                  </p>",
    "sort": 110
  },
  {
    "id": "portal-roadmap-suggestions-how-do-i-request-a-new-asset",
    "surface": "portal",
    "section": "Baking List",
    "question": "How do I request a new asset?",
    "answer_html": "<p>Open <strong>Baking List</strong> → <strong>Suggest an asset</strong>. Describe what you need. Likes help prioritize.</p><p>A suggestion is not a promise. Status moves to On the sheet / in progress only when I decide to build it.</p>",
    "sort": 120
  },
  {
    "id": "portal-roadmap-suggestions-what-do-the-roadmap-statuses-mean",
    "surface": "portal",
    "section": "Baking List",
    "question": "What do the Baking List statuses mean?",
    "answer_html": "<p>\n                    <strong>Suggestion</strong>: in the pile.\n                    <strong>On the sheet</strong>: planned.\n                    <strong>In progress</strong>: being built.\n                    <strong>Fresh out · ready</strong>: shipped (often linked from the Asset Jar).\n                  </p>",
    "sort": 130
  },
  {
    "id": "portal-baking-list-how-do-i-report-content",
    "surface": "portal",
    "section": "Baking List",
    "question": "How do I report spam or harmful content?",
    "answer_html": "<p>On a Baking List card, use <strong>Report</strong> (opens email), or write <a href=\"mailto:cookiecodejar@proton.me\">cookiecodejar@proton.me</a> with the item id and a short reason. Same email works for overlay-request concerns.</p>",
    "sort": 135
  },
  {
    "id": "portal-bake-off-what-is-bake-off",
    "surface": "portal",
    "section": "Bake-Off",
    "question": "What is Bake-Off?",
    "answer_html": "<p>Themed look contests Cookie runs in the kitchen. During <strong>Open</strong> you submit an entry, during <strong>Voting</strong> the community votes, and after Cookie announces results winners get prizes (often credits). Some placement winners may also appear in the Lookbook with a Bake-Off badge.</p>",
    "sort": 136
  },
  {
    "id": "portal-bake-off-how-do-i-enter-or-vote",
    "surface": "portal",
    "section": "Bake-Off",
    "question": "How do I enter or vote?",
    "answer_html": "<p>Open <strong>Bake-Off</strong>, pick a contest, then submit while it is Open. Heart an entry to vote while Voting is on. One entry and one vote per contest. Click your vote again to take it off. You cannot vote for your own look.</p>",
    "sort": 137
  },
  {
    "id": "portal-bake-off-when-do-winners-get-prizes",
    "surface": "portal",
    "section": "Bake-Off",
    "question": "When do winners get prizes?",
    "answer_html": "<p>After Cookie announces results, not the moment voting ends. Until then the contest may show as waiting. Credits and thank-you notes land with that announcement. Lookbook winner looks are posted by Cookie separately.</p>",
    "sort": 138
  },
  {
    "id": "portal-privacy-data-what-can-other-members-see-on-my-profile",
    "surface": "portal",
    "section": "Privacy & data",
    "question": "What can other members see on my profile?",
    "answer_html": "<p>Signed-in authors may see your pen name, photo, Episode handle (if set), tier badge, member since, and Baking List suggestion count.</p><p>They do <strong>not</strong> see your email, credits, unlocks, or birth date. On your birthday, a cake may appear by your pen name so people can celebrate.</p>",
    "sort": 140
  },
  {
    "id": "portal-privacy-data-what-shows-on-the-roadmap",
    "surface": "portal",
    "section": "Privacy & data",
    "question": "What shows on the Baking List?",
    "answer_html": "<p>\n                    Suggestions and comments show your pen name unless you post anonymously.\n                    Comments may store a snapshot of your profile photo from when you posted.\n                    Edits to your pen name later do not rewrite old Baking List rows automatically.\n                  </p>",
    "sort": 150
  },
  {
    "id": "portal-privacy-data-who-can-access-my-account-data-behind-the-scenes",
    "surface": "portal",
    "section": "Privacy & data",
    "question": "Who can access my account data behind the scenes?",
    "answer_html": "<p>Your private profile (email, credits, tier, unlocks, Ko-fi link, birthday) is only readable by you in the app.</p><p>Admin tools are for support, billing sync, overlay queues, and moderation. Card data stays on Ko-fi.</p>",
    "sort": 160
  },
  {
    "id": "portal-privacy-data-what-happens-to-reference-images-i-send-with-ove",
    "surface": "portal",
    "section": "Privacy & data",
    "question": "What happens to reference images I send with overlay requests?",
    "answer_html": "<p>References are only for building your overlay. Not sold, reused, or shown to other members. While open, only you and admin can access the file. After delivery (or cancel), it is deleted from server storage.</p><p>The finished overlay is yours to download. Cookie may later offer general overlays to other members (for example in the Asset Jar). If yours is personal (story-specific names, private plot details, or only-for-you art), say so in the request description so it stays private.</p><p>Details: <a href=\"privacy.html\">Privacy</a> and <a href=\"asset-usage.html\">Asset usage</a>.</p>",
    "sort": 170
  },
  {
    "id": "portal-privacy-data-what-happens-when-i-delete-my-account",
    "surface": "portal",
    "section": "Privacy & data",
    "question": "What happens when I delete my account?",
    "answer_html": "<p>On <strong>Profile → Delete account</strong>, confirm with your password. That removes Firebase sign-in and your private profile (credits, tier, unlocks).</p><ul><li>My Stash unlocks go away with the account.</li><li>Cancel Ko-fi billing separately.</li><li>Old Baking List posts may still show the pen name you used then.</li></ul>",
    "sort": 180
  },
  {
    "id": "portal-account-profile-how-do-i-change-my-pen-name-or-profile-photo",
    "surface": "portal",
    "section": "Account & profile",
    "question": "How do I change my pen name or profile photo?",
    "answer_html": "<p>\n                    Go to <strong>Profile</strong>. Click the pencil next to your pen name to edit it, or use\n                    <strong>Upload photo</strong> under your avatar. Your pen name appears on suggestions and comments.\n                  </p>",
    "sort": 190
  },
  {
    "id": "portal-account-profile-what-is-the-episode-username-field",
    "surface": "portal",
    "section": "Account & profile",
    "question": "What is the Episode username field?",
    "answer_html": "<p>\n                    Optional. Put your Episode username so people can find your stories. Separate from your\n                    CookieCodeJar pen name, only used for the profile link.\n                  </p>",
    "sort": 200
  },
  {
    "id": "portal-account-profile-i-did-not-get-my-verification-email",
    "surface": "portal",
    "section": "Account & profile",
    "question": "I did not get my verification email",
    "answer_html": "<p>\n                    Check spam and promotions folders. On the sign-in screen, use <strong>Resend confirmation email</strong>.\n                    If the button in the email does not work, use <strong>Copy link</strong> in that email and paste it\n                    in your browser.\n                  </p>",
    "sort": 210
  },
  {
    "id": "portal-account-profile-how-do-i-change-my-password-or-delete-my-account",
    "surface": "portal",
    "section": "Account & profile",
    "question": "How do I change my password or delete my account?",
    "answer_html": "<p>\n                    Both are on <strong>Profile</strong> under Account security and Danger zone. Deleting the account\n                    wipes your CookieCodeJar profile and credits, but not Ko-fi. Cancel billing there separately.\n                  </p>",
    "sort": 220
  },
  {
    "id": "portal-using-assets-in-episode-can-i-use-the-backgrounds-i-purchase-in-featured",
    "surface": "portal",
    "section": "Using assets in Episode",
    "question": "Can I use the backgrounds I purchase in Featured and Official stories?",
    "answer_html": "<p>\n                    Yes  -  Featured and Official Episode stories are fine, as long as you're the only author using those files.\n                    Please don't share them with other writers. Other Episode apps or anything outside Episode Interactive?\n                    Ask me first and I'll sort it out.\n                  </p>",
    "sort": 230
  },
  {
    "id": "portal-using-assets-in-episode-can-i-use-backgrounds-i-downloaded-for-stories-i",
    "surface": "portal",
    "section": "Using assets in Episode",
    "question": "Can I use backgrounds I downloaded for stories I collaborate on with other authors?",
    "answer_html": "<p>\n                    Yes, but the co-author shouldn't reuse the files in their own separate stories.\n                    Keep them on the Episode account that bought them, or on a shared Episode account you both use.\n                  </p>",
    "sort": 240
  },
  {
    "id": "portal-using-assets-in-episode-outfit-look-names-how-do-i-use-them",
    "surface": "portal",
    "section": "Using assets in Episode",
    "question": "Outfit look names: how do I use them?",
    "answer_html": "<p>\n                    In <strong>Lookbook</strong>, use the gender, color, and style filters (or search)\n                    to narrow looks. Open one you like and copy the item names into Episode's wardrobe search.\n                  </p>",
    "sort": 250
  }
];

export const FAQ_SEED_LANDING = [
  {
    "id": "landing-what-is",
    "surface": "landing",
    "section": "Getting started",
    "question": "What is CookieCodeJar?",
    "answer_html": "<p>CookieCodeJar is a membership kitchen of Episode assets: templates, overlays, mini-games, backgrounds, and outfit lookbooks. Unlock with credits, then re-download anytime from My Stash.</p>",
    "sort": 10
  },
  {
    "id": "landing-need-membership",
    "surface": "landing",
    "section": "Getting started",
    "question": "Do I need a Ko-fi membership?",
    "answer_html": "<p>No. Free accounts can browse, grab free Asset Jar items, vote on the Baking List, and peek at the Lookbook. Ko-fi memberships add monthly credits, Members Pantry, and paid-tier extras.</p>",
    "sort": 20
  },
  {
    "id": "landing-how-credits",
    "surface": "landing",
    "section": "Credits",
    "question": "How do credits work?",
    "answer_html": "<p>Credits unlock Asset Jar items. Paid Ko-fi tiers refill credits each month. Unused credits stay in your jar. Unlock once, download again from My Stash with no second charge.</p>",
    "sort": 30
  }
];

export const FAQ_SEED = [...FAQ_SEED_PORTAL, ...FAQ_SEED_LANDING];
